import ReactDiffViewer, { DiffMethod } from "react-diff-viewer";
import { Log } from "src/types.g";
import { getAllKeys, parseIfJsonString } from "./utils";

export const UpdateLogView = (props: { log: Partial<Log> }) => {
  const before = props.log.previousFields;
  const after = props.log.changedFields;

  return (
    <table className="log-details-table">
      <thead className="table-header">
        <tr>
          <th>Data Field</th>
          <th>Before Value</th>
          <th>After Value</th>
        </tr>
      </thead>
      <tbody>
        {getAllKeys(before, after).map((key) => {
          let beforeVal = before?.[key];
          let afterVal = after?.[key];
          beforeVal = parseIfJsonString(beforeVal);
          afterVal = parseIfJsonString(afterVal);
          const isObject =
            (typeof beforeVal === "object" && beforeVal !== null) ||
            (typeof afterVal === "object" && afterVal !== null);

          if (isObject) {
            return (
              <tr key={key}>
                <td className="td-key" title={key}>
                  {key}
                </td>
                <td className="td-json-diff" colSpan={2}>
                  <ReactDiffViewer
                    compareMethod={DiffMethod.LINES}
                    oldValue={JSON.stringify(beforeVal ?? {}, null, 2)}
                    newValue={JSON.stringify(afterVal ?? {}, null, 2)}
                    splitView={true}
                    showDiffOnly={false}
                  />
                </td>
              </tr>
            );
          }
          return (
            <tr key={key}>
              <td className="td-key" title={key}>
                {key}
              </td>
              <td className="td-before-general">{String(beforeVal ?? "")}</td>
              <td className="td-after-general">{String(afterVal ?? "")}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
